import Page from "~/pages/posts/[id]/index";
export default Page;
